export { default } from './CoverSubtitle';
